import React, { ReactNode, createContext, useContext, useState } from 'react';

interface ModalContextType {
  showTooManyPendingOfferModal: boolean;
  setShowTooManyPendingOfferModal: any;
  modalArgs: any;
  setModalArgs: any;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

// Create a provider for the modal context
export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showTooManyPendingOfferModal, setShowTooManyPendingOfferModal] = useState<boolean>(false);

  const [modalArgs, setModalArgs] = useState<any>(null);

  return (
    <ModalContext.Provider
      value={{
        showTooManyPendingOfferModal,
        setShowTooManyPendingOfferModal,
        modalArgs,
        setModalArgs,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

// Custom hook to use the modal context
export const useCommonModal = (): ModalContextType => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
